import { getCookie } from './Cookies';

function getTokens() {
  const wcToken = getCookie('WC_TOKEN');
  const userId = wcToken ? wcToken.split('%')[0] : '';
  const wcTrustedToken = getCookie(`WC_AUTHENTICATION_${userId}`);

  const WC_ACTIVEPOINTER = getCookie('WC_ACTIVEPOINTER');
  const WC_AUTHENTICATION = getCookie(`WC_AUTHENTICATION_${userId}`);
  const WC_PERSISTENT = getCookie('WC_PERSISTENT');
  const WC_SESSION_ESTABLISHED = getCookie('WC_SESSION_ESTABLISHED');
  const WC_TOKEN = getCookie('WC_TOKEN');
  const WC_TRUSTED_TOKEN = getCookie('WC_TRUSTED_TOKEN');
  const WC_USERACTIVITY = getCookie(`WC_USERACTIVITY_${userId}`);

  const cookies = {
    userId,
    WC_ACTIVEPOINTER,
    WC_AUTHENTICATION,
    WC_PERSISTENT,
    WC_SESSION_ESTABLISHED,
    WC_TOKEN,
    WC_TRUSTED_TOKEN,
    WC_USERACTIVITY,
  };

  return {
    wcToken: () => decodeURIComponent(wcToken),
    wcTrustedToken: () => wcTrustedToken,
    cookies: () => cookieMaker(cookies), // only for change-password service
  };
}

const cookieMaker = (cookies) => {
  return `WC_ACTIVEPOINTER=${cookies.WC_ACTIVEPOINTER}; WC_AUTHENTICATION_${cookies.userId}=${cookies.WC_AUTHENTICATION}; WC_PERSISTENT=${cookies.WC_PERSISTENT}; WC_SESSION_ESTABLISHED=${cookies.WC_SESSION_ESTABLISHED}; WC_TOKEN=${cookies.WC_TOKEN}; WC_TRUSTED_TOKEN=${cookies.WC_TRUSTED_TOKEN}; WC_USERACTIVITY_${cookies.userId}=${cookies.WC_USERACTIVITY};`;
};

export default getTokens;
